import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { AppContainer } from './app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ConfigProvider } from 'antd';
import { HelmetProvider } from 'react-helmet-async';

/* Styles */
import 'styles/App.css';
import 'styles/index.css';
import 'styles/font.css';
import 'styles/antd.css';
import 'styles/colors.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <ConfigProvider>
        <AppContainer />
      </ConfigProvider>
    </HelmetProvider>
    {process.env.REACT_APP_DEPLOY_TYPE !== 'production' && (
      <div style={{ fontSize: 16 }}>
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-right"
        />
      </div>
    )}
  </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
